// extracted by mini-css-extract-plugin
module.exports = {"item":"Evidence_item_Nm6BU"};